import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import {FormattedNumberWithSpace} from '@epmc-mach/accelarator/overrides/app/utils/currency-utils'
import {useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'
import {getShippingDisplayInfo} from '@epmc-mach/accelarator/overrides/app/utils/shipping-utils'

const PriceBreakdown = ({basket, fontSize = 'md'}) => {
    const hasDiscount =
        basket?.productSubTotal != null &&
        basket?.productTotal != null &&
        basket.productSubTotal !== basket.productTotal
    const discountAmount = hasDiscount ? basket.productSubTotal - basket.productTotal : 0
    const shippingInfo = getShippingDisplayInfo(basket)

    const {tCart} = useTranslationHelpers()
    return (
        <Stack w="full">
            <Flex justify="space-between" aria-live="polite" aria-atomic="true">
                <Text fontSize="md" color="black">
                    {tCart?.summarySubtotal}
                </Text>
                <Text fontSize="lg" color="black">
                    <FormattedNumberWithSpace
                        currency={basket?.currency}
                        value={basket?.productSubTotal}
                    />
                </Text>
            </Flex>

            {hasDiscount && (
                <Flex justify="space-between" aria-live="polite" aria-atomic="true">
                    <Text fontSize="lg" color="black">
                        {tCart?.summaryLabelDiscount}
                    </Text>
                    <Text fontSize="lg" color="error">
                        -{' '}
                        <FormattedNumberWithSpace
                            currency={basket?.currency}
                            value={discountAmount}
                        />
                    </Text>
                </Flex>
            )}
            {shippingInfo.showDiscount && (
                <Flex justify="space-between" aria-live="polite" aria-atomic="true">
                    <Text fontSize="lg" color="black">
                        {tCart?.summaryLabelDiscount}
                    </Text>
                    <Text fontSize="lg" color="error">
                        -{' '}
                        <FormattedNumberWithSpace
                            currency={basket?.currency}
                            value={shippingInfo.discountAmount}
                        />
                    </Text>
                </Flex>
            )}

            {shippingInfo.showOriginalPrice && (
                <Flex justify="space-between" aria-live="polite" aria-atomic="true">
                    <Text fontSize="lg" color="black">
                        {tCart?.summaryShipping}
                    </Text>
                    <Text fontSize="lg" color="black">
                        <FormattedNumberWithSpace
                            value={shippingInfo.originalPrice}
                            currency={basket.currency}
                        />
                    </Text>
                </Flex>
            )}

            {shippingInfo.showFree && (
                <Flex justify="space-between" aria-live="polite" aria-atomic="true">
                    <Text fontSize="lg" color="black">
                        {tCart?.summaryShipping}
                    </Text>
                    <Text fontSize="lg" color="black">
                        {tCart?.summaryFree}
                    </Text>
                </Flex>
            )}
        </Stack>
    )
}

PriceBreakdown.propTypes = {
    basket: PropTypes.object.isRequired,
    fontSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
}

export default PriceBreakdown
